import React, { Component } from "react";
import ReactTable from "react-table";
import { Configurations } from '../../Utils/Configurations';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import axios from 'axios';



class NotificationsItemDetails extends Component {

    constructor(props) {
        super(props);

        this.carregaListaItensAvisos = this.carregaListaItensAvisos.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.refreshTableItensAvisos = this.refreshTableItensAvisos.bind(this);
        this.selecionaUsuario = this.selecionaUsuario.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            hasError: false,
            errorMessage: '',
            listaItensAvisos: [],
            paginasItensAvisos: 1
        }
        this.columns = [
            {
                Header: 'Usuário',
                accessor: 'idUsuario',
                className: 'text-center pointer',
                width: 100,

            },
            {
                Header: 'Nome',
                accessor: 'Nome',
                className: 'text-center pointer',
                width: 250,

            },
            {
                Header: 'Tipo de contato',
                accessor: 'contato',
                className: 'text-center pointer',
                width: 250,

            },
            {
                Header: 'Aberto',
                accessor: 'abriu',
                className: 'text-center pointer',
                width: 250,
                Cell: row => (row.value ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-danger"></i>)

            },
            {
                Header: 'Clicado',
                accessor: 'clicou',
                className: 'text-center pointer',
                Cell: row => (row.value ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-danger"></i>)


            },
        ]
    }



    refreshTableItensAvisos(o) {
        this.carregaListaItensAvisos(o);
    }

    carregaListaItensAvisos(o) {
        this.setState({ isLoadingAvisos: true })
        let pagina, tamanhoPagina;
        if (o === undefined) {
            pagina = 0;
            tamanhoPagina = 20;
        }
        else if (!o.pageSize) {
            tamanhoPagina = this.state.limite;
        } else if (!(o.page + 1)) {
            pagina = this.state.pagina;
        } else {
            tamanhoPagina = o.pageSize;
            pagina = o.page;
            this.setState({
                pagina: pagina,
                limite: tamanhoPagina
            })
        }
        const _idAviso = this.props.match.params.idAviso,
            _itemsNotifications = axios.get(this.Configurations.apiBasePath + `/aviso-vencimento/avisos/${_idAviso}/itens?page=${pagina + 1}&pageSize=${tamanhoPagina}`);
        _itemsNotifications.then(response => {
            this.setState({
                listaItensAvisos: response.data.dados,
                total: response.data.resumo.total,
                abertos: response.data.resumo.abertos,
                clicados: response.data.resumo.clicados,
                idTipo: response.data.tipoDisparo.id,
                paginasItensAvisos: response.data.paginacao.totalPaginas
            });
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingAvisos: false
        }));
    }
    selecionaUsuario(idUsuario) {
        this.props.history.push(`/assinante/${idUsuario}`);
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    render() {
        return (
            <div className="row notifications-item-list">
                <div className="col-10">
                    <div className="row no-gutters text-left">
                        <h2>Avisos - Lista de Itens</h2>
                    </div>
                </div>
                <div className="col-2">
                    <div className="row no-gutters text-right">
                        <div className="col py-2 py-lg-0">
                            <button onClick={() => this.props.history.push(`/avisos/lista`)} className="btn btn-outline-secondary">voltar</button>
                        </div>
                    </div>
                </div>
                <div className="col-12 my-3 text-center">
                    <div className="row no-gutters">
                        <div className={`col-4 ${this.state.idTipo === 1 ? '' : "offset-2"}`}>
                            <div className="row px-2">
                                <div className="col-12 px-5">
                                    <div className="card">
                                        <div className="card-header">
                                            <strong className="m-0">Total</strong>
                                        </div>
                                        <div className="card-body py-2">
                                            <h1 className="m-0">{this.state.total}</h1>
                                            {this.state.total === 1 ? (
                                                <p>aviso</p>
                                            ) : (
                                                <p>avisos</p>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.idTipo === 1 && (
                            <React.Fragment>
                                <div className="col-4">
                                    <div className="row px-2">
                                        <div className="col-12 px-5">
                                            <div className="card">
                                                <div className="card-header">
                                                    <strong className="m-0">Abertos</strong>
                                                </div>
                                                <div className="card-body py-2">
                                                    <h1 className="m-0">{this.state.abertos}</h1>
                                                    {this.state.abertos === 1 ? (
                                                        <p>aviso</p>
                                                    ) : (
                                                        <p>avisos</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                        <div className="col-4">
                            <div className="row px-2">
                                <div className="col-12 px-5">
                                    <div className="card">
                                        <div className="card-header">
                                            <strong className="m-0">Clicados</strong>
                                        </div>
                                        <div className="card-body py-2">
                                            <h1 className="m-0">{this.state.clicados}</h1>
                                            {this.state.clicados === 1 ? (
                                                <p>aviso</p>
                                            ) : (
                                                <p>avisos</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="card mt-2">
                        <div className="card-body p-0">
                            <ReactTable
                                data={this.state.listaItensAvisos}
                                columns={this.columns}
                                onFetchData={this.refreshTableItensAvisos}
                                defaultPageSize={20}
                                pages={this.state.paginasItensAvisos}
                                page={this.state.pagina}
                                manual
                                pageSize={this.state.limite}
                                loading={this.state.isLoadingAvisos}
                                className="-striped -highlight"
                                headerClassName="ebs-table-header"
                                previousText='Anterior'
                                nextText='Próximo'
                                loadingText='Carregando...'
                                noDataText='Nenhum item encontrado.'
                                pageText='Página'
                                ofText='de'
                                rowsText='linhas'
                                getTdProps={(state, rowInfo, column, instance) => {
                                    return {
                                        onClick: (e, handleOriginal) => {
                                            if (rowInfo) {
                                                this.selecionaUsuario(rowInfo.original.idUsuario)
                                            }
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>

        )
    }


}

export default NotificationsItemDetails;